import { useEffect } from 'react';

export default function PanelKeyboardNav({ expand, toggleExpand, onPrev, onNext }) {
    useEffect(() => {
        if(!expand) return;

        const handleKeyDown = (e) => {
            if(e.key === 'ArrowUp' || e.key === 'ArrowDown'){
                e.preventDefault();
                const panelBody = document.querySelector('.panel-expand .panel-body');
                if(panelBody){
                    panelBody.scrollBy({ top: e.key === 'ArrowDown' ? 120 : -120, behavior: 'smooth' });
                }
            } else if(e.key === 'ArrowLeft'){
                onPrev?.();
            } else if(e.key === 'ArrowRight'){
                onNext?.();
            } else if(e.key === 'Escape'){
                toggleExpand?.();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [expand, toggleExpand, onPrev, onNext]);

    return null;
}
